import { GameState } from '../types/GameState';
import { Tile } from './tiles';

export const applyDynamicBoardIfNeeded = async (game: GameState) => {
  if (!game.config?.dynamicBoard) return null;

  const board = typeof game.board === 'string' ? JSON.parse(game.board) : game.board;
  const occupancy = getBoardOccupancy(board);
  const config = game.config as any;
  
  // Check trigger
  if (occupancy >= (config.dynamicTrigger || 0.7) && 
      game.turnCount % (config.cleanupIntervalTurns || 2) === 0) {
    return await removeOldTiles(game);
  }
  return null;
};

export const getBoardOccupancy = (board: any[][]): number => {
  let occupied = 0;
  let total = 0;
  for (let r = 0; r < board.length; r++) {
    for (let c = 0; c < (board[0]?.length || 0); c++) {
      total++;
      if (board[r][c]) occupied++;
    }
  }
  return occupied / total;
};

export const removeOldTiles = async (game: GameState) => {
  const board = typeof game.board === 'string' ? JSON.parse(game.board) : game.board;
  const removable = getRemovableTiles(board);
  const toRemove = selectOldestTiles(removable, (game.config as any)?.tilesToRemoveMin || 1, (game.config as any)?.tilesToRemoveMax || 2);
  
  if (toRemove.length === 0) return null;

  const newBoard = removeTilesFromBoard(board, toRemove);
  const freedCells = markFreedCells(toRemove);

  return {
    board: newBoard,
    freedCells: [...(game.freedCells || []), ...freedCells]
  };
};

export const getRemovableTiles = (board: any[][]) => {
  const tiles: {row: number, col: number, tile: Tile}[] = [];
  for (let r = 0; r < board.length; r++) {
    for (let c = 0; c < (board[0]?.length || 0); c++) {
      if (board[r][c]) {
        tiles.push({row: r, col: c, tile: board[r][c]});
      }
    }
  }
  return tiles;
};

export const selectOldestTiles = (tiles: {row: number, col: number, tile: Tile}[], min: number, max: number) => {
  // Sort by placedTurn
  const sorted = [...tiles].sort((a, b) => (a.tile.placedTurn || 0) - (b.tile.placedTurn || 0));
  const count = Math.floor(Math.random() * (max - min + 1)) + min;
  return sorted.slice(0, count);
};

export const removeTilesFromBoard = (board: any[][], toRemove: {row: number, col: number}[]) => {
  const newBoard = board.map(row => [...row]);
  toRemove.forEach(({row, col}) => {
    newBoard[row][col] = null;
  });
  return newBoard;
};

export const markFreedCells = (toRemove: {row: number, col: number}[]) => {
  return toRemove.map(({row, col}) => ({row, col, turn: Date.now()}));
};
